import { S3Client, GetObjectCommand, PutObjectCommand, DeleteObjectCommand } from "@aws-sdk/client-s3";
import { fromCognitoIdentityPool } from "@aws-sdk/credential-providers";

const REGION = process.env.REACT_APP_AWS_REGION || "us-east-2";
const BUCKET = "mitchellcampbellwebsite";
const KEY = "data_in/events.json";
const PHOTO_KEY = "data_in/family-photo.jpg";
const EVENTS_CACHE_KEY = "mc_events";
const PHOTO_CACHE_KEY = "mc_family_photo";

const s3 = new S3Client({
  region: REGION,
  credentials: fromCognitoIdentityPool({
    clientConfig: { region: REGION },
    identityPoolId: process.env.REACT_APP_COGNITO_IDENTITY_POOL_ID,
  }),
});

export function getCachedEvents() {
  try {
    const raw = localStorage.getItem(EVENTS_CACHE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch { return null; }
}

function setEventsCache(events) {
  try { localStorage.setItem(EVENTS_CACHE_KEY, JSON.stringify(events)); } catch {}
}

export function getCachedPhoto() {
  try { return localStorage.getItem(PHOTO_CACHE_KEY) || null; } catch { return null; }
}

function setPhotoCache(dataUrl) {
  try { localStorage.setItem(PHOTO_CACHE_KEY, dataUrl); } catch {}
}

function clearPhotoCache() {
  try { localStorage.removeItem(PHOTO_CACHE_KEY); } catch {}
}

export async function fetchEvents() {
  try {
    const res = await s3.send(new GetObjectCommand({ Bucket: BUCKET, Key: KEY }));
    const text = await res.Body.transformToString();
    const data = JSON.parse(text);
    setEventsCache(data);
    return data;
  } catch (e) {
    if (e.name === "NoSuchKey") return [];
    throw e;
  }
}

export async function saveEvents(events) {
  setEventsCache(events);
  await s3.send(new PutObjectCommand({
    Bucket: BUCKET,
    Key: KEY,
    Body: JSON.stringify(events),
    ContentType: "application/json",
  }));
}

export async function fetchPhoto() {
  const cached = getCachedPhoto();
  if (cached) return cached;
  try {
    const res = await s3.send(new GetObjectCommand({ Bucket: BUCKET, Key: PHOTO_KEY }));
    const bytes = await res.Body.transformToByteArray();
    const blob = new Blob([bytes], { type: "image/jpeg" });
    const dataUrl = await new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = e => resolve(e.target.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
    setPhotoCache(dataUrl);
    return dataUrl;
  } catch (e) {
    if (e.name === "NoSuchKey") return null;
    throw e;
  }
}

export async function savePhoto(dataUrl) {
  setPhotoCache(dataUrl);
  const blob = await fetch(dataUrl).then(r => r.blob());
  const bytes = new Uint8Array(await blob.arrayBuffer());
  await s3.send(new PutObjectCommand({
    Bucket: BUCKET,
    Key: PHOTO_KEY,
    Body: bytes,
    ContentType: "image/jpeg",
  }));
}

export async function deletePhoto() {
  clearPhotoCache();
  await s3.send(new DeleteObjectCommand({ Bucket: BUCKET, Key: PHOTO_KEY }));
}
